import React, { useState } from "react";
import Parameters from "./Parameters";
import KpiSelectors from "./KpiSelectors";
import BenchMarkingSummary from "./BenchMarkingSummary";
import CompanyBenchMarkingSummary from "./CompanyBenchMarkingSummary";

function UnifiedBenchmarkFlow({ compareCompanyView }) {
  const [isParametersComplete, setIsParametersComplete] = useState(false);
  const [hasKpiSelection, setHasKpiSelection] = useState(false);
  const [parametersSignature, setParametersSignature] = useState("");
  const [kpiSignature, setKpiSignature] = useState("");

  const handleParametersSelectionChange = ({ isComplete, selectionSignature }) => {
    setIsParametersComplete(Boolean(isComplete));
    setParametersSignature(selectionSignature || "");

    if (!isComplete) {
      setHasKpiSelection(false);
    }
  };

  const handleKpiSelectionChange = ({ hasKpiSelection: hasSelection, selectionSignature }) => {
    setHasKpiSelection(Boolean(hasSelection));
    setKpiSignature(selectionSignature || "");
  };

  const summaryRefreshKey = `${compareCompanyView ? "compare" : "benchmark"}|${parametersSignature}|${kpiSignature}`;

  return (
    <div className="bg-[#f4fbf6]">
      <div className="relative z-30">
        <Parameters
          compareCompanyView={compareCompanyView}
          hideContinueButton
          onContinue={() => {}}
          onSelectionChange={handleParametersSelectionChange}
        />
      </div>
{isParametersComplete && (
      <div id="unified-kpi-section" className="relative z-10">
        <KpiSelectors
          compareCompanyView={compareCompanyView}
          isEnabled={isParametersComplete}
          hideContinueButton
          onContinue={() => {}}
          onSelectionChange={handleKpiSelectionChange}
        />
      </div>
)}
      {isParametersComplete && hasKpiSelection && (
        <div id="unified-summary-section" className="relative z-0">
          {compareCompanyView ? (
            <CompanyBenchMarkingSummary
              key={summaryRefreshKey}
              compareCompanyView={compareCompanyView}
            />
          ) : (
            <BenchMarkingSummary
              key={summaryRefreshKey}
              compareCompanyView={compareCompanyView}
            />
          )}
        </div>
      )}
    </div>
  );
}

export default UnifiedBenchmarkFlow;
